import { createAPI } from '@common'

export default {
  // 积分修改
  postUcScoreRuleEdit: config => createAPI('customEncryptApiName-1/0w20vd0tdpsf0svmf0feju', 'post', config),
  // 积分重置
  postUcScoreRuleReset: config => createAPI('customEncryptApiName-1/0w20vd0tdpsf0svmf0sftfu', 'post', config)
}
